import {
  cn,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "web-design-system";
import { ChevronDownIcon } from "lucide-react";

export const Section = ({
  title,
  children,
  className,
  dirtyFields,
  defaultOpen = false,
  open,
  onOpenChange,
}: {
  title: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
  dirtyFields?: string[];
  defaultOpen?: boolean;
  // Optional controlled state, for sections that need to expand themselves.
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  return (
    <Collapsible
      defaultOpen={defaultOpen}
      open={open}
      onOpenChange={onOpenChange}
      className={cn("group border-b border-border", className)}
    >
      <CollapsibleTrigger className="w-full py-5 flex items-center justify-between">
        {typeof title === "string" ? (
          <span className="text-base font-semibold">{title}</span>
        ) : (
          title
        )}
        <div className="gap-4 flex items-center">
          {dirtyFields?.length ? (
            <span className="text-muted-foreground text-sm group-data-[state=open]:hidden">
              Edits in {dirtyFields.join(", ")}
            </span>
          ) : null}
          <ChevronDownIcon className="size-4 group-data-[state=open]:rotate-180" />
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className="pb-5">{children}</CollapsibleContent>
    </Collapsible>
  );
};
